module.exports = __webpack_public_path__ + "static/img/Jordan-Riki.041f177.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jordan-Riki.jpg
// module id = hiU7
// module chunks = 0